import React, { useEffect, useState } from "react";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  LayoutDashboard, Users, CalendarDays, CalendarRange, Briefcase, Calculator,
  Database, LogOut, Building2, FileText, MessageSquare, ListPlus, BarChart3, Crown, Bot, Webhook,
  Wand2, PieChart, History, Megaphone, FolderTree, Sparkles, ChevronsLeft, ChevronsRight,
  TrendingUp, Landmark, Layers, FolderOpen, Settings, KeyRound, Swords, Zap, CalendarClock, Wallet, FileX2, Newspaper,
} from "lucide-react";
import { cn } from "@/lib/utils";

const ROLE_LABELS = {
  admin:       "Admin",
  leader:      "Team Leader",
  agent:       "Agente",
  wa_operator: "Op. WhatsApp",
};

export const NAV = [
  { to: "/",                     end: true, label: "Dashboard",          icon: LayoutDashboard, testid: "nav-dashboard",  roles: ["admin","leader","agent","wa_operator"] },
  { to: "/clienti",              label: "Clienti",                        icon: Users,           testid: "nav-clients",    roles: ["admin","leader","agent"] },
  { to: "/intelligence",         label: "Intelligence",                   icon: Newspaper,       testid: "nav-intelligence", roles: ["admin","leader","agent"] },
  { to: "/lead-ads",             label: "Lead Google Ads",                icon: Megaphone,       testid: "nav-lead-ads", roles: ["admin","leader","agent"] },
  { to: "/portafogli",           label: "Portafogli",                     icon: FolderTree,      testid: "nav-portfolios", roles: ["admin","leader"] },
  { to: "/portafoglio-attivo",   label: "Portafoglio Attivo",             icon: Wallet,          testid: "nav-active-portfolio", roles: ["admin","leader","agent"] },
  { to: "/comandante",           label: "Comandante AI",                  icon: Sparkles,        testid: "nav-commander",  roles: ["admin","leader","agent"] },
  { to: "/arena",                label: "Arena",                          icon: Swords,          testid: "nav-arena",      roles: ["admin","leader","agent"] },
  { to: "/boost-storico",        label: "Storico Boost",                  icon: Zap,             testid: "nav-boost-history", roles: ["admin","leader","agent"] },
  { to: "/aree-di-lavoro",       label: "Aree di Lavoro",                 icon: Layers,          testid: "nav-workspaces", roles: ["admin","leader","agent"] },
  { to: "/documenti",            label: "Documenti Utili",                icon: FolderOpen,      testid: "nav-documents",  roles: ["admin","leader","agent"] },
  { to: "/crosssell",            label: "Cross-sell AI",                  icon: TrendingUp,      testid: "nav-crosssell",  roles: ["admin","leader","agent"] },
  { to: "/conoscenza",           label: "Knowledge Base",                 icon: FileText,        testid: "nav-knowledge",  roles: ["admin","leader"] },
  { to: "/glossario?kind=finanziaria", label: "Finanziarie",             icon: Landmark,        testid: "nav-finanziarie",roles: ["admin","leader","agent"] },
  { to: "/glossario?kind=azienda",     label: "Aziende",                 icon: Building2,       testid: "nav-aziende",    roles: ["admin","leader","agent"] },
  { to: "/agenda",               label: "Agenda",                         icon: CalendarDays,    testid: "nav-agenda",     roles: ["admin","leader","agent"] },
  { to: "/calendario",           label: "Calendario",                     icon: CalendarRange,   testid: "nav-calendar",   roles: ["admin","leader","agent"] },
  { to: "/pipeline",             label: "Pratiche del Mese",              icon: Briefcase,       testid: "nav-pipeline",   roles: ["admin","leader","agent"] },
  { to: "/campagne",             label: "Campagne WA",                    icon: Megaphone,       testid: "nav-campaigns",  roles: ["admin","leader","agent"] },
  { to: "/inbox",                label: "Inbox WhatsApp",                 icon: MessageSquare,   testid: "nav-inbox",      roles: ["admin","leader","agent"] },
  { to: "/coach",                label: "Coach AI",                       icon: Bot,             testid: "nav-coach",      roles: ["admin","leader","agent"] },
  { to: "/statistiche",          label: "Statistiche",                    icon: PieChart,        testid: "nav-stats",      roles: ["admin","leader"] },
  { to: "/confronto",            label: "Confronto Mese",                 icon: BarChart3,       testid: "nav-compare",    roles: ["admin","leader"] },
  { to: "/preventivatore",       label: "Preventivatore PP",              icon: FileText,        testid: "nav-pp",         roles: ["admin","leader","agent"] },
  { to: "/strumenti",            label: "Calcolatori",                    icon: Calculator,      testid: "nav-tools",      roles: ["admin","leader","agent"] },
  { to: "/messaggi",             label: "Messaggi WA",                    icon: MessageSquare,   testid: "nav-wa",         roles: ["admin","leader","agent"] },
  { to: "/campi",                label: "Campi Custom",                   icon: ListPlus,        testid: "nav-fields",     roles: ["admin"] },
  { to: "/dati",                 label: "Import / Export",                icon: Database,        testid: "nav-data",       roles: ["admin","leader"] },
  { to: "/cronologia",           label: "Recupero / Cronologia",          icon: History,         testid: "nav-recovery",   roles: ["admin","leader"] },
  { to: "/piano-recall",         label: "Piano Recall",                   icon: CalendarClock,   testid: "nav-recall-plan", roles: ["admin"] },
];

export const ADMIN_NAV = [
  { to: "/team",                    label: "Team & Permessi",          icon: Crown,         testid: "nav-team",        roles: ["admin"] },
  { to: "/integrazioni/whatsapp",   label: "WhatsApp / WAHA",          icon: MessageSquare, testid: "nav-wa-int",      roles: ["admin"] },
  { to: "/audit",                   label: "Audit log",                icon: History,       testid: "nav-audit",       roles: ["admin"] },
  { to: "/integrazioni",            label: "Integrazioni",             icon: Webhook,       testid: "nav-integrations",roles: ["admin"] },
  { to: "/duplicati",               label: "Pulizia Duplicati",        icon: Wand2,         testid: "nav-dedup",       roles: ["admin"] },
  { to: "/impostazioni/motivi-rifiuto",  label: "Motivi di rifiuto",    icon: FileX2,        testid: "nav-reject-reasons", roles: ["admin"] },
  { to: "/impostazioni/sidebar",    label: "Personalizza Sidebar",     icon: Settings,      testid: "nav-sidebar-builder", roles: ["admin","leader","agent"] },
  { to: "/vault",                   label: "Vault Password",           icon: KeyRound,      testid: "nav-vault",            roles: ["admin","leader","agent"] },
];

function visibleFor(role, items) {
  return items.filter((it) => !it.roles || it.roles.includes(role || "admin"));
}

const COLLAPSE_KEY = "sidebar:collapsed";

export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem(COLLAPSE_KEY) === "1"; } catch { return false; }
  });
  useEffect(() => {
    try { localStorage.setItem(COLLAPSE_KEY, collapsed ? "1" : "0"); } catch {}
    window.dispatchEvent(new CustomEvent("sidebar-collapsed", { detail: collapsed }));
  }, [collapsed]);
  return [collapsed, setCollapsed];
}

/* ─── BA Monogram ─── */
function SidebarLogo({ collapsed }) {
  return (
    <div className={cn("h-16 flex items-center border-b", collapsed ? "justify-center" : "px-5 gap-3")}
      style={{ borderColor: 'rgba(255,255,255,0.07)' }}>
      <img src="/brand/logo-mark.png" alt="Best Agent" className="shrink-0 rounded-[4px] object-cover"
        style={{ width: 34, height: 34 }} data-testid="sidebar-logo-img" />
      {!collapsed && (
        <div>
          <div className="font-serif text-[16px] leading-tight text-white font-light tracking-tight">Best Agent</div>
          <div className="text-[9px] uppercase tracking-[0.22em] mt-0.5" style={{ color: 'var(--gold)' }}>Private Wealth CRM</div>
        </div>
      )}
    </div>
  );
}

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const role = user?.role || "admin";
  const [sidebarPrefs, setSidebarPrefs] = useState({ hidden: [], order: [] });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/prefs`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("ba_access_token") || ""}` }
        });
        if (r.ok) {
          const d = await r.json();
          const s = d?.preferences?.sidebar || {};
          if (!cancelled) setSidebarPrefs({ hidden: s.hidden || [], order: s.order || [] });
        }
      } catch {}
    })();
    return () => { cancelled = true; };
  }, []);

  const customize = (items) => {
    let arr = visibleFor(role, items);
    arr = arr.filter((it) => !sidebarPrefs.hidden.includes(it.to));
    if (sidebarPrefs.order.length > 0) {
      const idx = (to) => { const i = sidebarPrefs.order.indexOf(to); return i === -1 ? 999 : i; };
      arr = [...arr].sort((a, b) => idx(a.to) - idx(b.to));
    }
    return arr;
  };

  const visibleNav   = customize(NAV);
  const visibleAdmin = customize(ADMIN_NAV);
  const [collapsed, setCollapsed] = useSidebarCollapsed();
  const widthCls = collapsed ? "w-[60px]" : "w-[220px]";

  const linkCls = ({ isActive }) => cn(
    "sidebar-item flex items-center my-[1px] text-[13px] font-medium",
    collapsed ? "mx-1.5 px-1.5 py-2.5 justify-center rounded" : "mx-2 px-3 py-[7px] gap-2.5 rounded-[3px]",
    isActive ? "sidebar-item-active" : "",
  );

  // NOTE: NIENTE più mouseEnter/Leave inline JS.
  // Hover + active state sono GESTITI VIA CSS in index.css (.sidebar-item, .sidebar-item-active)
  // per evitare il conflitto con il React style prop che rendeva invisibile il testo al mouseLeave.

  return (
    <aside
      className={cn(
        "sidebar-dark fixed top-0 left-0 h-screen flex flex-col z-40 transition-[width] duration-200 ease-out",
        widthCls,
      )}
      style={{ background: 'var(--navy)', borderRight: '1px solid rgba(255,255,255,0.06)' }}
      data-testid="app-sidebar"
      data-collapsed={collapsed ? "1" : "0"}
    >
      <SidebarLogo collapsed={collapsed} />

      {/* Collapse button */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        data-testid="sidebar-collapse-btn"
        title={collapsed ? "Espandi sidebar" : "Comprimi sidebar"}
        className="absolute -right-3 top-[72px] z-50 w-6 h-6 rounded-full flex items-center justify-center shadow-lg transition-colors"
        style={{ background: 'var(--gold)', color: 'var(--navy)', border: '1.5px solid var(--navy)' }}
      >
        {collapsed ? <ChevronsRight className="w-3 h-3" /> : <ChevronsLeft className="w-3 h-3" />}
      </button>

      {/* Nav */}
      <nav className="flex-1 py-3 overflow-y-auto overflow-x-hidden">
        {!collapsed && (
          <div className="px-4 pb-2 pt-1 text-[9px] uppercase tracking-[0.2em]" style={{ color: 'rgba(100,116,139,0.7)' }}>
            Console operativa
          </div>
        )}

        {visibleNav.map((it) => {
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              title={collapsed ? it.label : undefined}
              className={linkCls}
            >
              <Icon className="w-[15px] h-[15px] shrink-0" strokeWidth={1.6} />
              {!collapsed && <span className="truncate">{it.label}</span>}
            </NavLink>
          );
        })}

        {visibleAdmin.length > 0 && (
          <>
            <div className="mx-3 my-3" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }} />
            {!collapsed && (
              <div className="px-4 pb-2 text-[9px] uppercase tracking-[0.2em]" style={{ color: 'rgba(183,149,91,0.6)' }}>
                Amministrazione
              </div>
            )}
            {visibleAdmin.map((it) => {
              const Icon = it.icon;
              const itPath  = it.to.split("?")[0];
              const itQuery = it.to.split("?")[1] || "";
              const active  = itQuery
                ? (location.pathname === itPath && location.search.includes(itQuery))
                : location.pathname === itPath;
              return (
                <NavLink
                  key={it.to}
                  to={it.to}
                  data-testid={it.testid}
                  title={collapsed ? it.label : undefined}
                  className={cn(
                    "sidebar-item flex items-center my-[1px] text-[13px] font-medium",
                    collapsed ? "mx-1.5 px-1.5 py-2.5 justify-center rounded" : "mx-2 px-3 py-[7px] gap-2.5 rounded-[3px]",
                    active ? "sidebar-item-active" : "",
                  )}
                >
                  <Icon className="w-[15px] h-[15px] shrink-0" strokeWidth={1.6} />
                  {!collapsed && <span className="truncate">{it.label}</span>}
                </NavLink>
              );
            })}
          </>
        )}
      </nav>

      {/* User footer */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }} className="p-2.5">
        {!collapsed ? (
          <>
            <Link
              to="/profilo"
              data-testid="profile-link"
              title="Profilo e notifiche"
              className="flex items-center gap-2.5 mb-2.5 px-2 py-1.5 -mx-2 rounded transition-colors"
              style={{ color: "inherit", textDecoration: "none" }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.05)"}
              onMouseLeave={e => e.currentTarget.style.background = ""}
            >
              <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold shrink-0"
                style={{ background: 'rgba(183,149,91,0.18)', color: 'var(--gold)', border: '1px solid rgba(183,149,91,0.25)' }}>
                {(user?.name || user?.email || "U").slice(0, 1).toUpperCase()}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-[13px] text-white font-medium truncate leading-tight">{user?.name || "Utente"}</div>
                <div className="text-[10px] truncate mt-0.5" style={{ color: 'var(--gold)' }}>{ROLE_LABELS[role] || "Utente"}</div>
              </div>
            </Link>
            <button
              onClick={async () => { await logout(); nav("/login"); }}
              data-testid="logout-button"
              className="w-full flex items-center justify-center gap-1.5 px-3 py-1.5 text-[12px] transition-colors"
              style={{ color: 'rgba(148,163,184,0.7)', borderRadius: 3, border: '1px solid rgba(255,255,255,0.07)' }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.color = '#fff'; }}
              onMouseLeave={e => { e.currentTarget.style.background = ''; e.currentTarget.style.color = 'rgba(148,163,184,0.7)'; }}
            >
              <LogOut className="w-3.5 h-3.5" strokeWidth={1.6} />
              Esci
            </button>
          </>
        ) : (
          <button
            onClick={async () => { await logout(); nav("/login"); }}
            data-testid="logout-button"
            title="Esci"
            className="w-full flex items-center justify-center py-2 transition-colors"
            style={{ color: 'rgba(148,163,184,0.6)' }}
            onMouseEnter={e => e.currentTarget.style.color = '#fff'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(148,163,184,0.6)'}
          >
            <LogOut className="w-4 h-4" strokeWidth={1.6} />
          </button>
        )}
      </div>
    </aside>
  );
}
